import React from "react";
import { CSSTransition } from "react-transition-group";

import { ReactComponent as LoaderAnimation } from "~/legacy-assets/loader.svg";

type LoaderProps = { loading: boolean };

export default class Loader extends React.Component<LoaderProps> {
	render() {
		const { loading } = this.props;
		return (
			<CSSTransition in={!loading} timeout={200} unmountOnExit appear>
				<div className="fellow-loader">
					<LoaderAnimation />
				</div>
			</CSSTransition>
		);
	}
}
